import AddGcodeModal from "./AddGcodeModal"

import React, {useEffect, useState} from "react"

import { Link } from "react-router-dom";

import { supabase } from './SupabaseClient'
import { useRecoilState } from 'recoil'
import { authSessionState } from '../atoms/auth'

import PrintDataCard from "./PrintDataCard";

export default function PrintDataList() {
  const [session, set_session] = useRecoilState(authSessionState)
  const [print_data_list, set_print_data_list]:any[] = useState<any[]>([])

  useEffect(() => {

    handleGetPrintData()
  },[])

  const handleGetPrintData = async ()=>{
    const {data, error} = await supabase.from('print_data').select()


    console.log("GET gcode data")
    console.log(data)

    set_print_data_list(data)
  }
 
  return (
    <>
      <div className="bg-white py-6 sm:py-8 lg:py-12">
        <div className="px-4 md:px-8 mx-auto">
          <div className="flex flex-col gap-4 mb-6">
            <h1 className="text-gray-800 text-2xl lg:text-3xl font-bold">プリントデータ</h1>

            {
            //<Link to="/add-gcode"  className="inline-block bg-white hover:bg-gray-100 active:bg-gray-200 focus-visible:ring ring-indigo-300 border text-gray-500 text-sm md:text-base font-semibold text-center rounded-lg outline-none transition duration-100 px-4 md:px-8 py-2 md:py-3">Add Gcode</Link>
            }
            <Link to="/add-printdata"  className="inline-block w-60 bg-blue-500 hover:bg-blue-700 active:bg-blue-800 focus-visible:ring ring-indigo-300 border text-white text-sm md:text-base font-semibold text-center rounded-lg outline-none transition duration-100 px-4 md:px-8 py-2 md:py-3 border border-blue-700 ">プリントデータの追加</Link>
          </div>


          <div className="grid sm:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-6 gap-x-4 md:gap-x-6 gap-y-8">
            {
              print_data_list.map((data:any)=>{
                return <PrintDataCard key={data.id} print_data={data} reload_data={handleGetPrintData}></PrintDataCard>
              })

            }

          </div>
        </div>
      </div>
    </>
  )
}